import { EventEmitter } from '@angular/core';
import { UXFacetGroup } from '../../models/ux-facets';
var FacetgroupComponent = /** @class */ (function () {
    function FacetgroupComponent() {
        this.facetToggled = new EventEmitter();
        this.groupToggled = new EventEmitter();
    }
    Object.defineProperty(FacetgroupComponent.prototype, "name", {
        get: function () {
            return this.group.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetgroupComponent.prototype, "facets", {
        get: function () {
            return this.group.facets;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacetgroupComponent.prototype, "groupIsShown", {
        get: function () {
            // check if group has at least one applied facet
            if (this.appliedFacets && this.appliedFacets.length > 0) {
                return true;
            }
            else {
                return !!(this.group.facets && this.group.facets.length > 1);
            }
        },
        enumerable: true,
        configurable: true
    });
    FacetgroupComponent.prototype.toggled = function (event) {
        this.facetToggled.emit(event);
    };
    FacetgroupComponent.prototype.facetgroupToggled = function () {
        this.groupToggled.emit(this.group.code);
    };
    return FacetgroupComponent;
}());
export { FacetgroupComponent };
